import {BehaviourByNames} from "@/item-editor/constants/BehaviourTypes";
let SiblingGamePlayConstant = require("@/item-editor/constants/SiblingGamePlayConstant");
const MIN_GHOST_COUNT_TO_GEN = 30;
const MAX_GHOST_COUNT_TO_GEN_DMG = 40;
const MAX_GHOST_COUNT_TO_GEN_GOLD = 50;
const MAX_GHOST_COUNT_TO_GEN_HP = 40;
const MIN_GHOST_COUNT_TO_GEN_SPEED = 15;
const MAX_GHOST_COUNT_TO_GEN_SPEED = 30;
const MAX_GHOST_COUNT_TO_GEN_MANA = 40;
const MIN_GHOST_COUNT_TO_GEN_STUN_BOSS = 10;
const MAX_GHOST_COUNT_TO_GEN_STUN_BOSS = 11;
const MAX_DIFF_GEN = 25;
const MIN_DIFF_GEN = 0.5;
const MIN_LEVEL_PER_CHANGE_ITEM = 10;//at less 10 stages to change new item
const MIN_REVIVE_SUPPORT_TO_GEN = 1;

class AutomateMergeItemByGPConfigUtils  {

    constructor (automateCreateItemOptions) {
        this.automateCreateItemOptions = automateCreateItemOptions;
        this.initItemUtils();
    }

    setListAutoplayStateData(listAutoplayStateData){
        //use for all stages
        this.listAutoplayStateData = listAutoplayStateData;

        //test under 400 stages
        //this.listAutoplayStateData = listAutoplayStateData.filter(s => s.stage <= 400).sort((a, b) => (a.stage < b.stage));
    }

    applyConfig(config){
        if(this.isHasImplementImpact(config.impactType)){
            if(this.isBonusForGoldFarmingRequire(config.impactType)){
                if(this.isGenerateBalanceItem()){
                    let ls = this.listAutoplayStateData;//.filter(s => s.ghostFarming > MIN_GHOST_COUNT_TO_GEN).sort((a, b) => (a.stage < b.stage));
                    this.defineConfig(config, ls, 'ghostFarming', this.getMultiplierForGold(), MIN_GHOST_COUNT_TO_GEN, MAX_GHOST_COUNT_TO_GEN_GOLD);
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            } else if(this.isBonusForDmgRequire(config.impactType)){
                if(this.isIncludeDmgItem()){
                    let ls = this.listAutoplayStateData;
                    if(this.isIncludeExtraDmgItem()){
                        this.defineConfig(config, ls, 'ghostFarming', this.getDmgPercentForOptional(), MIN_GHOST_COUNT_TO_GEN, MAX_GHOST_COUNT_TO_GEN_DMG, 5, 2);
                    } else {
                        this.defineConfig(config, ls, 'ghostFarming', this.getDmgPercentForOptional(), MIN_GHOST_COUNT_TO_GEN, MAX_GHOST_COUNT_TO_GEN_DMG);
                    }
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            } else if(this.isBonusForReviveHero(config.impactType)){
                if(this.getIsCanCustomRevive() && this.getIsIncludeHeroRevive()){
                     this.defineReviveConfigByCustom(config, undefined);
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            } else if(this.isBonusForReviveSupport(config.impactType)){
                if(this.getIsCanCustomRevive() && this.getIsIncludeSupportRevive()){
                     let ls = this.listAutoplayStateData.filter(s => s.reviveBestSupport >= MIN_REVIVE_SUPPORT_TO_GEN).sort((a, b) => (a.stage < b.stage));
                     this.defineReviveConfigByCustom(config, ls);
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            } else if(this.isBonusForHpRequire(config.impactType)){
                if(this.isIncludeHpItem()){
                    let ls = this.listAutoplayStateData;
                    this.defineConfig(config, ls, 'ghostFarming', this.getHpPercentForOptional(), MIN_GHOST_COUNT_TO_GEN, MAX_GHOST_COUNT_TO_GEN_HP);
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            } else if(this.isBonusForIncSpeedRequire(config.impactType)){
                if(this.isIncludeIncSpeedItem()){
                    let ls = this.listAutoplayStateData;
                    this.defineConfig(config, ls, 'ghostFarming', this.getIncSpeedPercent(config.impactType), MIN_GHOST_COUNT_TO_GEN_SPEED, MAX_GHOST_COUNT_TO_GEN_SPEED);
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            } else if(this.isBonusForIncManaRequire(config.impactType)){
                if(this.isIncludeIncManaItem()){
                    let ls = this.listAutoplayStateData;
                    this.defineConfig(config, ls, 'ghostFarming', this.getIncManaPercent(config.impactType), MIN_GHOST_COUNT_TO_GEN, MAX_GHOST_COUNT_TO_GEN_MANA);
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            } else if(this.isBonusForStunBossRequire(config.impactType)){
                if(this.isIncludeStunBossItem()){
                    let ls = this.listAutoplayStateData;
                    this.defineConfig(config, ls, 'ghostFarming', this.getPercentForStunBossItem(config.impactType), MIN_GHOST_COUNT_TO_GEN_STUN_BOSS, MAX_GHOST_COUNT_TO_GEN_STUN_BOSS);
                } else {
                    config.itemRootCount = 0;
                    config.isApplySimulator = false;
                }
            }
        }
    }

    isGenerateBalanceItem(){
        return this.automateCreateItemOptions.isGenBalanceItem;
    }

    isIncludeOptionItem(){
        return this.automateCreateItemOptions.isIncludeOptional;
    }

    getMultiplierForGold(){
        return this.automateCreateItemOptions.optionalRatioGoldItem;
    }

    getMultiplierForOptional(){
        return this.automateCreateItemOptions.optionalRatioItem;
    }

    getIsCanCustomRevive(){
        return this.automateCreateItemOptions.isCustomRevive;
    }

    getIsIncludeHeroRevive(){
        return this.getLevelStartHeroRevive() > 0;
    }

    getLevelStartHeroRevive(){
        return this.automateCreateItemOptions.levelStartHeroRevive;
    }

    getIsIncludeSupportRevive(){
        return this.automateCreateItemOptions.isIncludeSupportRevive;
    }

    getLevelStartSupportRevive(dataList){
        if(dataList && dataList.length > 0){
            return dataList[0].stage;
        } else {
            return 500;
        }
    }
    //==============================================
    //=========local================================
    initItemUtils(){
        this.doneImplementImpact = [];
        this.impactsForDmgRequire = [];
        this.impactsForHpRequire = [];
        this.impactForGoldFarmingRequire = [];
        this.impactsForIncSpeedRequire = [];
        this.impactsForIncManaRequire = [];
        this.impactsForStunBossRequire = [];

        this.addImpactToListDMGRequire(BehaviourByNames.damageEnemy);

        this.addImpactToListHpRequire(BehaviourByNames.incHp);
        this.addImpactToListHpRequire(BehaviourByNames.fillHp);

        this.addImpactToListIncSpeedRequire(BehaviourByNames.incCriticalHitRatio);
        this.addImpactToListIncSpeedRequire(BehaviourByNames.incDps);
        this.addImpactToListIncSpeedRequire(BehaviourByNames.incSpeedSupport);
        this.addImpactToListIncSpeedRequire(BehaviourByNames.incPetActiveTime);
        
        this.addImpactToListGoldFarmingRequire(BehaviourByNames.incGoldEnemyDrop);
        this.addImpactToListGoldFarmingRequire(BehaviourByNames.incGoldDrop);

        this.addImpactToListIncManaRequire(BehaviourByNames.fillMana);
        this.addImpactToListIncManaRequire(BehaviourByNames.incMana);
        this.addImpactToListIncManaRequire(BehaviourByNames.incManaRefillSpeed);
        this.addImpactToListIncManaRequire(BehaviourByNames.incPowerUpCapacity);

        this.addImpactToListStunBossfRequire(BehaviourByNames.freezeEnemy);
        this.addImpactToListStunBossfRequire(BehaviourByNames.poisonEnemy);
        this.addImpactToListStunBossfRequire(BehaviourByNames.sheepEnemy);
        
        this.addImpactToListReviveRequire(BehaviourByNames.reviveHero);
        this.addImpactToListReviveRequire(BehaviourByNames.reviveSupport);
    }

    addImpactToListDMGRequire(type){
        this.impactsForDmgRequire.push(type);
        this.doneImplementImpact.push(type);
    }

    addImpactToListHpRequire(type){
        this.impactsForHpRequire.push(type);
        this.doneImplementImpact.push(type);
    }

    addImpactToListStunBossfRequire(type){
        this.impactsForStunBossRequire.push(type);
        this.doneImplementImpact.push(type);
    }

    addImpactToListGoldFarmingRequire(type){
        this.impactForGoldFarmingRequire.push(type);
        this.doneImplementImpact.push(type);
    }

    addImpactToListReviveRequire(type){
        this.doneImplementImpact.push(type);
    }

    addImpactToListIncSpeedRequire(type){
        this.impactsForIncSpeedRequire.push(type);
        this.doneImplementImpact.push(type);
    }

    addImpactToListIncManaRequire(type){
        this.impactsForIncManaRequire.push(type);
        this.doneImplementImpact.push(type);
    }

    defineConfig(config, dataList, key, multiplier, minAmount, maxAmount, extraCloneCount, extraAmountAdding) {
        if (dataList.length > 0) {

            let minPercent = 0.0;
            let maxPercent = 0.0;
            let genMinAmount = 0;
            let genMaxAmount = 0;
            let rootGenCount = 1;
            if(extraCloneCount){
                rootGenCount = extraCloneCount;
                config.extraLstGeneric = [];
            }

            for(let genCount = rootGenCount; genCount > 0 ; genCount--){
                if(genCount > 1 && extraAmountAdding){
                    genMinAmount = minAmount + genCount * extraAmountAdding;
                    genMaxAmount = maxAmount + genCount * extraAmountAdding;
                } else {
                    genMinAmount = minAmount;
                    genMaxAmount = maxAmount;
                }
                let lstGeneric = [];
                let startLevel = 0;
                let percent = 0.0;
                let nextPercent = 0.0;
                if (dataList.length === 1) {
                    percent = this.getPercentByGhostFarmCounter(dataList[0][key], multiplier, genMinAmount, genMaxAmount);
                    if(percent > 0){
                        minPercent = percent;
                        maxPercent = percent;
                        if(this.isAllowAppear(config.impactType, dataList[0].stage)){
                            lstGeneric.push({
                                startLevel: dataList[0].stage,
                                minBonus: percent,
                                maxBonus: maxPercent,
                                endLevel: dataList[0].stage + 10
                            });
                        }
                    }
                } else {
                    percent = this.getPercentByGhostFarmCounter(dataList[0][key], multiplier, genMinAmount, genMaxAmount);
                    //startLevel = dataList[0].stage;
                    //let lastGroup1KItem = Math.floor(startLevel / 1000) * 1000;
                    for (let index = 1; index < dataList.length; index++) {
                        //let nextGroup1KItem = Math.floor(dataList[index].level / 1000) * 1000;
                        nextPercent = this.getPercentByGhostFarmCounter(dataList[index][key], multiplier, genMinAmount, genMaxAmount);

                        if(nextPercent > 0){
                            if(percent <= 0){
                                //starting level for item
                                percent = nextPercent;
                                startLevel = dataList[index].stage;
                                if (minPercent === 0 || minPercent > nextPercent) {
                                    minPercent = nextPercent;
                                }
                            }
                        }

                        let isLast = index === dataList.length - 1 && percent > 0;

                        if(dataList[index].stage - startLevel >= MIN_LEVEL_PER_CHANGE_ITEM || isLast){
                            let nextPercentPlusDiff = nextPercent + (MAX_DIFF_GEN * multiplier);
                            let nextPercentMinDiff = nextPercent - (MIN_DIFF_GEN * multiplier);
                            if (percent < nextPercentMinDiff || percent > nextPercentPlusDiff){
                                maxPercent = percent;
                                if(this.isAllowAppear(config.impactType, startLevel)){
                                    lstGeneric.push({
                                        startLevel: startLevel,
                                        minBonus: percent,
                                        maxBonus: maxPercent,
                                        endLevel: dataList[index].stage
                                    });
                                }
                                percent = nextPercent;
                                if(percent > 0){
                                    if (minPercent > nextPercent) {
                                        minPercent = nextPercent;
                                    }
                                    startLevel = dataList[index].stage;
                                }
                            } else {
                                if (isLast) {
                                    maxPercent = percent;
                                    if(this.isAllowAppear(config.impactType, startLevel)){
                                        lstGeneric.push({
                                            startLevel: startLevel,
                                            minBonus: percent,
                                            maxBonus: maxPercent,
                                            endLevel: dataList[index].stage >= 10 ? dataList[index].stage : startLevel + 10
                                        });
                                    }
                                }
                            }
                        }

                        //to allow item continue to appear until next require item was generate
                        let genCount = lstGeneric.length;
                        if (genCount > 1){
                            let currentGen = lstGeneric[genCount - 1];
                            let preGen = lstGeneric[genCount - 2];
                            if(currentGen.startLevel > preGen.endLevel){
                                preGen.endLevel = currentGen.startLevel;
                            }
                        }
                    }
                }

                 //to fix last item, should continue until end level of json
                if(lstGeneric.length > 0){
                    let lastGen = lstGeneric[lstGeneric.length - 1];
                    let lastStage = dataList[dataList.length - 1].stage;
                    if(lastGen.startLevel <= lastStage){
                        lastGen.endLevel = lastGen.startLevel + 10 < lastStage ? lastStage : lastGen.startLevel + 10;
                    }

                    //These data will display only so no need to take care
                    //define start item level appear
                    config.startLevel = lstGeneric[0].startLevel;
                    //define end level
                    config.endLevel = lastGen.endLevel - 1;
                }

                config.genItemCount = lstGeneric.length;
                config.itemRootCount = lstGeneric.length;
                if(config.extraLstGeneric && genCount > 1 && lstGeneric.length > 0){
                    config.extraLstGeneric.push(lstGeneric);
                } else {
                    config.lstGeneric = lstGeneric;
                }
            }

            config.minBonus = minPercent;
            config.maxBonus = maxPercent;
            config.isApplySimulator = true;

            //console.log("gen " + config.impactType, config);
        }
    }

    defineReviveConfigByCustom(config, dataList){
        let startLevel = 0;
        if(this.isBonusForReviveHero(config.impactType)){
            startLevel= this.getLevelStartHeroRevive();
        } else {
            startLevel= this.getLevelStartSupportRevive(dataList);
        }
        config.lstGeneric = [];
        config.lstGeneric.push({
            startLevel: startLevel,
            endLevel: -1
        });
        config.minBonus = 100;
        config.maxBonus = 100;
        config.startLevel = startLevel;
        config.endLevel = -1;
        config.genItemCount = config.lstGeneric.length;
        config.isApplySimulator = true;
        config.itemRootCount = config.lstGeneric.length;
        // console.log("gen " + config.impactType, config.lstGeneric);
    }

    getPercentByGhostFarmCounter(ghostCount, multi, minAmount, maxAmount){
        if(ghostCount < minAmount) return 0;
        let count = Math.min(ghostCount, maxAmount);
        return ((count-minAmount) * 100 * multi).toFixed(2);
    }

    isAllowAppear(impType, startLevel){
        if(this.isRequireHeroSkillUnlock(impType)){
            //automate static, first power up unlocked at stage 120
            if(startLevel < SiblingGamePlayConstant.min_stage_hero_skill_unlock){
                //console.log(' -> imp '+impType+ ' not allow level: '+startLevel);
                return false;
            }
        } else if (impType === BehaviourByNames.incPetActiveTime){
            if(startLevel < SiblingGamePlayConstant.min_stage_pet_unlock){
                //console.log(' -> imp '+impType+ ' not allow level: '+startLevel);
                return false;
            }
        } else if (this.isBossStuntItem(impType)){
            if(startLevel < SiblingGamePlayConstant.min_stage_boss_stunt_item){
                //console.log(' -> imp '+impType+ ' not allow level: '+startLevel);
                return false;
            }
        }
        return true;
    }

    isRequireHeroSkillUnlock(impType){
        return impType === BehaviourByNames.incPowerUpCapacity
                || impType === BehaviourByNames.incMana
                || impType === BehaviourByNames.incManaRefillSpeed
                || impType === BehaviourByNames.fillMana;
    }

    isBossStuntItem(impType){
        return impType === BehaviourByNames.sheepEnemy
            || impType === BehaviourByNames.poisonEnemy
            || impType === BehaviourByNames.freezeEnemy;
    }

    isHasImplementImpact(impType){
        return this.doneImplementImpact.includes(impType);
    }

    isBonusForDmgRequire(impType){
        return this.impactsForDmgRequire.includes(impType);
    }

    isIncludeDmgItem(){
        return this.automateCreateItemOptions.isIncludeDmg;
    }

    isIncludeExtraDmgItem(){
        //this feature not correct with user play experience
        //return this.automateCreateItemOptions.isExtraDmg;
        return false;
    }

    getDmgPercentForOptional(){
        return this.automateCreateItemOptions.dmgPercent;
    }

    isBonusForHpRequire(impType){
        return this.impactsForHpRequire.includes(impType);
    }

    isIncludeHpItem(){
        return this.automateCreateItemOptions.isIncludeHp;
    }

    getHpPercentForOptional(){
        return this.automateCreateItemOptions.hpPercent;
    }

    isBonusForGoldFarmingRequire(impType){
        return this.impactForGoldFarmingRequire.includes(impType);
    }

    isBonusForReviveHero(impType){
        return impType === BehaviourByNames.reviveHero;
    }

    isBonusForReviveSupport(impType){
        return impType === BehaviourByNames.reviveSupport;
    }

    isBonusForIncSpeedRequire(impType){
        return this.impactsForIncSpeedRequire.includes(impType);
    }

    isIncludeIncSpeedItem(){
        return this.automateCreateItemOptions.isIncSpeedItem;
    }

    getIncSpeedPercent(impType){
        let percent = this.automateCreateItemOptions.incSpeedPercent;
        if(impType === BehaviourByNames.incDps){
            return percent * 0.05;
        } else if(impType === BehaviourByNames.incPetActiveTime){
            return percent * 0.45;
        }
        return percent;
    }

    isBonusForIncManaRequire(impType){
        return this.impactsForIncManaRequire.includes(impType);
    }

    isIncludeIncManaItem(){
        return this.automateCreateItemOptions.isIncManaItem;
    }

    getIncManaPercent(impType){
        let percent = this.automateCreateItemOptions.incManaPercent;

        if(impType === BehaviourByNames.incMana){
            return percent * 0.25;
        } else if(impType === BehaviourByNames.incManaRefillSpeed){
            return percent * 0.20;
        } else if(impType === BehaviourByNames.incPowerUpCapacity){
            return percent * 0.15;
        }

        return percent;
    }

    isBonusForStunBossRequire(impType){
        return this.impactsForStunBossRequire.includes(impType);
    }

    isIncludeStunBossItem(){
        return this.automateCreateItemOptions.isIncludeStunBoss;
    }

    getPercentForStunBossItem(){
        return this.automateCreateItemOptions.bonusStunPercent;
    }
}

export default AutomateMergeItemByGPConfigUtils;
